<div class="color-blue-dark">
  <div class="grid">
    <div class="grid__box grid__box--size-6">
      <div class="title title--big">
        Добро пожаловать в {{ Enums.projectName }},
        {{ authData.employee['first_name'] }}
        !
      </div>
    </div>
    <div class="grid__box grid__box--size-6 grid__box--flex grid__box--justify-content-flex-end">
      <div class="color-gray-dark">Сегодня {{ currentDate | dateFormat: 'DD MMMM' }}</div>
    </div>
  </div>
  <div class="grid">
    <div class="grid__box grid__box--size-6">
      <div class="grid mt-16 color-gray-dark">
        <div class="grid__box grid__box--size-min">Вы вошли под ролью "{{ authData.current_group['name'] }}"</div>
        <div class="grid__box grid__box--size-min" *ngIf="authData.groups.length > 1">
          <a
            class="link link--dotted-gray-dark"
            [ngbPopover]="changeRolePopContent"
            placement="bottom-left"
            triggers="manual"
            [autoClose]="'outside'"
            #p2="ngbPopover"
            (click)="toggleWithChangeRoleContext(p2)"
            id="changeRolePseudoLink"
          >
            Сменить роль
          </a>
        </div>
      </div>
    </div>
    <div class="grid__box grid__box--size-6 grid__box--flex grid__box--justify-content-flex-end">
      <div>
        <div class="grid grid--gap-8 grid--va-middle mt-16">
          <div class="grid__box grid__box--size-min">
            <app-field>
              <content-prefix>
                <div class="field__input-prefix">
                  <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
                </div>
              </content-prefix>
              <input type="text" class="input-text input--prefix" id="ticketNumber" [(ngModel)]="ticketNumber" placeholder="Поиск по номеру заявки" />
            </app-field>
          </div>
          <div class="grid__box grid__box--size-min">
            <button type="button" class="button" id="appSearchTicket" [disabled]="!ticketNumber" (click)="onSearchTicket()">Искать</button>
          </div>
        </div>
        <div class="main-search-ticket__item">
          <span [hidden]="!searchTicketError" class="color-{{ searchTicketErrorHighlight }}">{{ searchTicketError }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="grid mt-48">
    <div class="grid__box grid__box--size-8">
      <div class="main-tiles">
        <div class="main-tiles__item" *ngIf="is(AuthGroupTypes.Admin) || is(AuthGroupTypes.Curator)">
          <a class="main-tiles__item-link" routerLink="{{ '/' + SECTORS_PATHS.monitoring }}" id="workShiftDivorceLink">
            <div class="item__header">
              <app-icon [glyph]="'monitoring'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Мониторинг работы участков</div>
          </a>
        </div>
        <div class="main-tiles__item" *ngIf="is(AuthGroupTypes.Dispatcher)">
          <a class="main-tiles__item-link" routerLink="{{ '/' + WORK_SHIFT_PATHS.work_shift }}" id="workShiftLink">
            <div class="item__header">
              <app-icon [glyph]="'clock'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Смена</div>
          </a>
        </div>
        <div class="main-tiles__item" *ngIf="is(AuthGroupTypes.DispatcherGRS)">
          <a class="main-tiles__item-link" routerLink="{{ '/' + WORK_SHIFT_PATHS.work_shift }}" [queryParams]="{ type: 'grs' }" id="workShiftLinkGrs">
            <div class="item__header">
              <app-icon [glyph]="'clock'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Смена ГРРС</div>
          </a>
        </div>
        <div class="main-tiles__item">
          <a class="main-tiles__item-link" routerLink="{{ '/' + NOTIFICATIONS_PATHS.notifications }}" id="notificationsLink">
            <div class="item__header">
              <app-icon [glyph]="'bell-main'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Уведомления</div>
          </a>
        </div>
        <div class="main-tiles__item" *ngIf="showCheckLists">
          <a class="main-tiles__item-link" routerLink="{{ '/' + CHECK_LISTS_PATHS.checkLists }}">
            <div class="item__header">
              <app-icon [glyph]="'check-lists'" class="check-list-icon" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Чек-листы</div>
          </a>
        </div>
        <div class="main-tiles__item" *ngIf="is(AuthGroupTypes.Dispatcher)">
          <a class="main-tiles__item-link" routerLink="{{ '/' + WORK_SHIFTS_PATHS.work_shifts }}" id="workShiftsLink">
            <div class="item__header">
              <app-icon [glyph]="'graphic'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">График рабочих смен</div>
          </a>
        </div>
        <div class="main-tiles__item" *ngIf="is(AuthGroupTypes.DispatcherGRS)">
          <a class="main-tiles__item-link" routerLink="{{ '/' + WORK_SHIFTS_PATHS.work_shifts }}" [queryParams]="{ prop: 'grs' }" id="workShiftsLinkGrs">
            <div class="item__header">
              <app-icon [glyph]="'graphic'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">График рабочих смен бригад ГРРС</div>
          </a>
        </div>
      </div>
      <div class="main-tiles">
        <app-role-access [action]="'visible'" [permission]="'employee.add'">
          <div class="main-tiles__item">
            <a class="main-tiles__item-link" routerLink="{{ '/' + USERS_PATHS.users_create }}" id="userCreateLink">
              <div class="item__header">
                <app-icon [glyph]="'user-main'" [size]="'48'" [color]="'gray-dark'"></app-icon>
              </div>
              <div class="item__content">Регистрация нового сотрудника</div>
            </a>
          </div>
        </app-role-access>
        <div class="main-tiles__item main-tiles__item--hover">
          <div class="item__slide">
            <div class="item__header">
              <app-icon [glyph]="'folder'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Справочники</div>
            <div class="reference-block">
              <div class="reference-block__header">Справочники</div>
              <div class="reference-block__content">
                <app-role-access [action]="'visible'" [permission]="'employee.get'">
                  <div>
                    <a class="link" routerLink="{{ '/' + USERS_PATHS.users }}" target="_blank" id="usersLink">Сотрудники</a>
                  </div>
                </app-role-access>
                <app-role-access [action]="'visible'" [permission]="'partnership.get'">
                  <div>
                    <a class="link" routerLink="{{ '/' + COMPANIES_PATHS.companies }}" target="_blank" id="companyLink">Компании</a>
                  </div>
                </app-role-access>
                <app-role-access [action]="'visible'" [permission]="'sector.get'">
                  <div>
                    <a class="link" routerLink="{{ '/' + SECTORS_PATHS.sectors }}" target="_blank" id="sectorsLink">Участки</a>
                  </div>
                </app-role-access>

                <app-role-access [action]="'visible'" [permission]="'normatives.get'">
                  <div>
                    <a class="link" routerLink="{{ '/' + NORMATIVES_PATHS.normatives }}" target="_blank" id="normativesLink">Нормативы</a>
                  </div>
                </app-role-access>

                <div>
                  <a class="link" routerLink="{{ '/' + USERS_PATHS.service_functions }}" target="_blank" id="serviceFunctionsLink">Функции</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-role-access [action]="'visible'" [permission]="'settings.get'">
          <div class="main-tiles__item">
            <a class="main-tiles__item-link" routerLink="{{ '/' + APP_SETTINGS_PATHS.settings }}" id="appSettingsLink">
              <div class="item__header">
                <app-icon [glyph]="'settings'" [size]="'48'" [color]="'gray-dark'"></app-icon>
              </div>
              <div class="item__content">Настройки системы</div>
            </a>
          </div>
        </app-role-access>
      </div>
    </div>
    <div class="grid__box grid__box--size-4" *ngIf="showSectorCalendar">
      <app-sector-calendar></app-sector-calendar>
    </div>
  </div>
</div>

<ng-template #changeRolePopContent>
  <div id="rolesPopover">
    <div class="mb-8">
      <span class="title title--s">Доступные роли</span>
    </div>
    <div class="mb-2 mt-2" *ngFor="let role of authData.groups">
      <button *ngIf="role.id !== authData.current_group.id" type="button" class="ctrl link" id="{{ 'role' + role.name + 'button' }}" (click)="onChangeRole(role)">
        {{ role.name }}
      </button>
    </div>
  </div>
</ng-template>
